import React from "react"
import MainMenu from "./Menus/MainMenu"

const Navigation = ({ ...props }) => {
  if (props.className === undefined) {
    props.className = ""
  }

  props.className += " navbar static h-full"

  return (
    <nav {...props}>
      <div id="navbarCollapsible" className="navbar-menu">
        <div className="container relative px-4 w-full max-w-full mx-0">
          <div className="navbar-menu-wrapper">
            <MainMenu />
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
